import React, { useEffect, useState } from "react"
import { accessFromProps } from "../lib/book-access"
import { BookShell } from "../components/book-shell"
import { PageHeader } from "../components/page-header"
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card"
import { Button } from "../components/ui/button"
import { ActiniumLoader, ACTINIUM_LOADER_SIZES } from "../components/ui/actinium-loader"
import { ActiniumLogo } from "../components/actinium-logo"

function SampleCell({ children, caption }) {
  return (
    <div className="flex min-h-[140px] flex-col items-center justify-center gap-3 rounded-lg border border-border/70 bg-background/80 px-4 py-5">
      {children}
      {caption ? <p className="text-center text-xs text-muted-foreground">{caption}</p> : null}
    </div>
  )
}

export function LoadersPage(props) {
  const { user_name } = props
  const access = accessFromProps(props)
  const [showFullscreen, setShowFullscreen] = useState(false)

  useEffect(() => {
    if (!showFullscreen) return undefined
    const t = window.setTimeout(() => setShowFullscreen(false), 2500)
    return () => window.clearTimeout(t)
  }, [showFullscreen])

  return (
    <BookShell activeSlug="home" userName={user_name} access={access}>
      <div className="flex flex-col gap-6">
        <PageHeader
          context="UI kit"
          title="Actinium Book loaders"
          description="A-shaped book mark with a rotating ring and three colored dots that blink in sequence."
        />

        <Card>
          <CardHeader>
            <CardTitle>Logo — book in A shape</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
              {[32, 48, 72, 96].map((size) => (
                <SampleCell key={size} caption={`${size}px`}>
                  <ActiniumLogo size={size} className="rounded-[22%] shadow-soft" />
                </SampleCell>
              ))}
            </div>
            <div className="mt-4 flex items-center gap-3 rounded-lg border border-border/70 bg-background/80 px-4 py-3">
              <ActiniumLogo size={40} className="rounded-[22%] shadow-sm" />
              <div>
                <p className="text-sm font-semibold tracking-tight text-foreground">Actinium Book</p>
                <p className="text-xs text-muted-foreground">Open book formed as the letter A</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Loader sizes</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
              {ACTINIUM_LOADER_SIZES.map((size) => (
                <SampleCell key={size} caption={size}>
                  <ActiniumLoader size={size} />
                </SampleCell>
              ))}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>With labels</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <SampleCell caption="Stacked label">
                <ActiniumLoader size="md" label="Loading your books…" />
              </SampleCell>
              <SampleCell caption="Inline label">
                <ActiniumLoader size="sm" layout="inline" label="Saving…" />
              </SampleCell>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Fullscreen overlay</CardTitle>
          </CardHeader>
          <CardContent className="flex flex-wrap items-center gap-3">
            <Button type="button" onClick={() => setShowFullscreen(true)}>
              Preview fullscreen loader
            </Button>
            <p className="text-sm text-muted-foreground">Closes automatically after 2.5 seconds.</p>
          </CardContent>
        </Card>

        {showFullscreen ? (
          <ActiniumLoader size="xl" label="Loading Actinium Book…" fullscreen />
        ) : null}
      </div>
    </BookShell>
  )
}
